import { Button } from '../../../../../../components/button/button';
import { Container } from '../../../../../../components/container/container';
import { Input } from '../../../../../../components/input/input';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { Select } from '../../../../../../components/select/select';
import { getSocialIcon } from '../../../../../../helpers/icon-maps';
import { useCreateExternalReviewModal } from './use-create-external-review-modal';
import { collectionFrequencyOptions } from './helpers';
import s from './create-external-review-modal.module.css';

export const CreateExternalReviewModal = (props: ModalProps) => {
  const {
    t,
    formData,
    setFormData,
    detectedSource,
    handleUrlChange,
    handleSubmit,
    isLoading,
  } = useCreateExternalReviewModal(props);

  const selectedFrequency = collectionFrequencyOptions.find(
    (f) => f.id === String(formData.repeat_per_day),
  );

  return (
    <Modal {...props} title={t('Добавить внешний источник')} className={s.feature}>
      <Container required label={t('Ссылка на профиль')}>
        <Input
          value={formData.profile_url || ''}
          onChange={(e) => handleUrlChange(e.currentTarget.value)}
          placeholder={t('Введите ссылку на профиль')}
        />
      </Container>

      {!!formData.profile_url && (
        <Container label={t('Определение ресурса')}>
          {detectedSource ? (
            <div className={s.sourceInfo}>
              <span className={s.sourceIcon}>
                {getSocialIcon(detectedSource.icon)}
              </span>
              <span>{detectedSource.name}</span>
            </div>
          ) : (
            <div className={s.sourceUnknown}>{t('Ресурс по ссылке не распознан')}</div>
          )}
        </Container>
      )}

      <Container required label={t('Периодичность сбора (раз в день)')}>
        <Select
          options={collectionFrequencyOptions}
          value={selectedFrequency}
          onSelect={(option) =>
            setFormData((prev) => ({ ...prev, repeat_per_day: Number(option.id) }))
          }
        />
      </Container>

      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Отмена')}
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
          {t('Добавить')}
        </Button>
      </div>
    </Modal>
  );
};
